<template>
    <v-btn
        :x-large="xLarge" 
        :block="block"
        :color="color"
        :class="textColor"
        @click="click"
        :style="style"
        :disabled="disabled"
        :outlined="outlined"
        :href="href"
        :icon="icon"
        :width="width"
        :height="height"
    >
        <slot>ボタン</slot>
    </v-btn>
</template>
<script>
    export default {
        data() {
            return {
                style: {
                    "font-size": this.fontSize + "px",
                    "font": this.font,
                    "font-weight": this.fontWeight,
                },
            }
        },
        props: {
            // 要素の高さ
            height: {
                type: String,
                default: "56"
            },
            // 要素の横幅
            width: {
                type: String,
                default: "200"
            },
            // フォントサイズ
            fontSize: {
                type: String,
                default: "20"
            },
            // フォント
            font: {
                type: String,
            },
            // フォントの太さ
            fontWeight: {
                type: String,
            },
            // カラー
            color: {
                type: String,
                default: "light-blue darken-1"
            },
            // テキスト色
            textColor: {
                type: String,
                default: "white--text"
            },
            // ボタンを使用可能な最大スペースまで広げる
            block: {
                type:Boolean,
                default: false,
            },
            // v-btnで規定された最大サイズを設定
            xLarge: {
                type: Boolean,
                default: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            // 外枠だけのデザインにする
            outlined: {
                type: Boolean,
                default: false
            },
            // リンク先の指定
            href: {
                type: String,
            },
            // ボタンをiconとして指定
            icon: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            click() {
                this.$emit('click');
            }
        }
    }
</script>